import React, { useEffect, useState } from "react";
import { hdfcPayment } from "../../store/slices/checkoutSlice";
import { useDispatch, useSelector } from "react-redux";
import HdfcRedirect from "../HdfcRedirect";
import { useParams } from "react-router-dom";
import { DashboardLoader } from "../DashboardLoader";

const TestPayment = () => {
  const dispatch = useDispatch();
  const { payment_id,country_id,price,type} = useParams();

  const { hdfc_status, hdfc_payment,data} = useSelector((state) => state.payment);
  const QA_URL = process.env.REACT_APP_APIURL_QA;
  const TEST_URL = process.env.REACT_APP_DEMO_SHAREAPI;
  const BASE_URL = process.env.REACT_APP_SHAREAPI;
  const backend_url = process.env.REACT_APP_APIURL_LIVE;
  let MainURL =
    process.env.REACT_APP_DEV_ENV == "PRODUCTION"
      ? BASE_URL
      : process.env.REACT_APP_DEV_ENV == "DEMO"
      ? TEST_URL
      : QA_URL;

  useEffect(() => {
          dispatch(
            hdfcPayment({
              redirect_url: `${backend_url}ccavenue/response-handler`,
              cancel_url: `${backend_url}ccavenue/response-handler`,
              plan_id: payment_id,
              type: type==="renew" ? "Plan" : type,
              country_dial_code: country_id,
            })
          ).unwrap()
            .then((res) => {
              let data = {
                amount: price,
                order_id: res.data.result.order_id,
              };
              localStorage.setItem("orderDetails", JSON.stringify(data));
            });
  }, []);

  if (hdfc_status == "success" && hdfc_payment?.order_id) {
    return <HdfcRedirect />;
  }

  return <DashboardLoader />;
};

export default TestPayment;
